import Cookies from 'js-cookie';
import axios, {
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse,
    AxiosError,
    InternalAxiosRequestConfig,
} from 'axios';
import { ApiError } from 'shared/types';

export const ApiKey = 'JOB45689ASD9857ASDSCRIPT';
const backendHost = Cookies.get('backendHost');
export class HttpClient {
    private static instance?: AxiosInstance;

    private static getInstance(): AxiosInstance {
        if (!HttpClient.instance) {
            HttpClient.instance = axios.create({
                baseURL: HttpClient.getBaseUrl(),
                headers: { 'Content-Type': 'application/json' },
            });

            HttpClient.instance.interceptors.request.use(
                (config) => {
                    const token = Cookies.get('tokenClient');
                    if (token) {
                        HttpClient.setAuthHeader(config, token);
                    } else {
                        if (config.headers['token']) {
                            HttpClient.clearAuthHeader(config);
                        }
                    }

                    return config;
                },
                (error) => Promise.reject(HttpClient.formatError(error))
            );

            HttpClient.instance.interceptors.response.use(
                (response) => response,
                (error) => Promise.reject(HttpClient.formatError(error))
            );
        }
        return HttpClient.instance;
    }

    private static getBaseUrl(): string | undefined {
        const BaseApi = backendHost
            ? backendHost
            : window.location.href.startsWith('https://grc.ua') ||
                window.location.href.startsWith('https://www.grc.ua')
              ? 'https://grc.ua/api'
              : window.location.href.startsWith('https://test19742.grc.ua/')
                ? 'https://test19742.grc.ua/api'
                : process.env.REACT_APP_API_URL;

        const prodAPI = 'https://grc.ua/api';
        return  prodAPI;
    }

    private static formatError(error: AxiosError): ApiError {
        if (error.response) {
            return {
                status: error.response.status,
                message: (error.response.data as any)?.message || 'Request failed',
                details: error.response.data,
            };
        } else if (error.request) {
            return {
                status: 0,
                message: 'No response from server',
                details: error.request,
            };
        } else {
            return {
                status: 0,
                message: error.message || 'Unexpected error',
            };
        }
    }

    // --- Set the auth header ---
    private static setAuthHeader(config: InternalAxiosRequestConfig, token: string) {
        config.headers['key'] = ApiKey;
        config.headers['token'] = token;
    }

    // --- Clear the auth header ---
    private static clearAuthHeader(config: InternalAxiosRequestConfig) {
        config.headers['key'] = null;
        config.headers['token'] = null;
    }

    static async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        const res: AxiosResponse<T> = await HttpClient.getInstance().get(url, config);
        return res.data;
    }

    static async post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
        const res: AxiosResponse<T> = await HttpClient.getInstance().post(url, data, config);
        return res.data;
    }

    static async put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
        const res: AxiosResponse<T> = await HttpClient.getInstance().put(url, data, config);
        return res.data;
    }

    static async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        const res: AxiosResponse<T> = await HttpClient.getInstance().delete(url, config);
        return res.data;
    }
}
